import React from 'react'
import styles from './Login.module.css'

const Field = ({ name, placeholder, type, handleChange, hidden }) => {

    return (
        <div>
            <input 
                className={styles.inputField} 
                type={type}
                name={name}
                hidden={hidden}
                placeholder={placeholder}
                onChange={handleChange} 
                required = {true}
            />
        </div>
    )
}

export default Field
